import Vue from 'vue';
import Router from 'vue-router';
import Introduction from '@/views/introduction/index.vue';
import Chapter from '@/views/chapter/index.vue';
import Content from '@/views/content/index.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'introduction',
      component: Introduction,
    },
    {
      path: '/capitulo/:chapterID',
      name: 'chapter',
      component: Chapter,
    },
    {
      path: '/capitulo/:chapterID/conteudo/:contentID',
      name: 'content',
      component: Content,
    },
  ],
});
